export default __webpack_public_path__ + "static/media/151-paint-roller.b5c42d0d.png";